module.exports = __webpack_public_path__ + "static/media/destination.eb9b38ad.svg";